import { createReducer } from '../commons/js/utils/reducer';

const initialstate = {
    showMyProfile: false,
    showPassword: false,
    showSideBarMobile: false,
    showOutlookPasswordChange: false,
    toggleScreenValue: { value: 'dashboard', label: 'Taskboard' },
    toggleGraphValue: { value: 'spoolsPerProjectGraph', label: 'Number of Spools per Project' },
    toggleForemanValue: {value: 'welder-average-report', label: 'Welders Average Report'},
    graphOptions: [
        { value: 'spoolsPerProjectGraph', label: 'Number of Spools per Project' },
        { value: 'linearFeet', label: 'Linear feet & Weight of Pipe shipped per day' },
        { value: 'weldsAndFit', label: 'Weld & Fit-Up Inches For The Shop' },
        { value: 'pipeSize', label: 'Pipe Size % for a Day' },
        { value: 'truckLoads', label: 'Truck Loads Report' },
        { value: 'fitter-average-report', label: 'Fitters Average Report' },
        { value: 'welder-average-report', label: 'Welders Average Report' },
        { value: 'completedActivityStats', label: 'Completed Weld Activity Stats' },
        { value: 'cut-time-tracking', label: 'Cut Time Tracking Report' },
        { value: 'weld-time-tracking', label: 'Welds Time Tracking Report' },
        { value: 'spool-time-tracking', label: 'Spools Time Tracking Report' },
        { value: 'package-time-tracking', label: 'Packages Time Tracking Report' },
        {value: 'field-work-log', label: 'Field Work Log' },
        {value: 'slope-time-tracking', label: 'Slope Time Tracking Report' },
        {value: 'field-welds-time-tracking', label: 'Field Welds Time Tracking Report' },
        {value: 'flange-time-tracking', label: 'Flange Time Tracking Report' },
        {value: 'pipeline-time-tracking', label: 'Pipeline Time Tracking Report' },
    ],
    pdfLoader: false,
    zoomIn: false,
    spoolSearch: '',
    showSwitchAccount: false,
    userRoles: []
}

const layoutReducer = createReducer(initialstate, {
    "SET_SHOW_MY_PROFILE": (state, action) => {
        return {
            ...state,
            showMyProfile: action.payload.value,
        }
    },
    "SET_SWITCH_ACCOUNT": (state, action) => {
        return {
            ...state,
            showSwitchAccount: action.payload.value,
        }
    },
    "SET_USER_ROLES": (state, action) => {
        return {
            ...state,
            userRoles: action.payload.value,
        }
    },

    "SET_SHOW_USER_CHANGE_PASSWORD": (state, action) => {
        return {
            ...state,
            showPassword: action.payload.value,
        }
    },

    "SET_SHOW_OUTLOOK_PASSWORD_CHANGE": (state, action) => {
        return {
            ...state,
            showOutlookPasswordChange: action.payload.value,
        }
    },

    "TOGGLE_MOBILE_SIDENAV": (state, action) => {
        return {
            ...state,
            showSideBarMobile: !state.showSideBarMobile,
        }
    },

    "CHANGE_SCREEN": (state, action) => {
        return {
            ...state,
            toggleScreenValue: action.payload.value,
        }
    },

    "CHANGE_GRAPH": (state, action) => {
        return {
            ...state,
            toggleGraphValue: action.payload.value,
        }
    },
    "SET_PDF_LOADER": (state, action) => {
        return {
            ...state,
            pdfLoader: action.payload.value,
        }
    },
    "SET_ZOOM_IN":(state, action) => {
        return {
            ...state,
            zoomIn: action.payload.value,
        }
    },
    "SET_SPOOL_SEARCH": (state, action) => {
        return {
            ...state,
            spoolSearch: action.payload.value
        }
    },
    "CHANGE_GRAPH_FOREMAN": (state, action) => {
        return {
            ...state,
            toggleForemanValue: action.payload.value,
        }
    },
});

export default layoutReducer;